import { render, staticRenderFns } from "./Selfscanning.vue?vue&type=template&id=231b3c25&scoped=true"
import script from "./Selfscanning.vue?vue&type=script&lang=js"
export * from "./Selfscanning.vue?vue&type=script&lang=js"
import style0 from "./Selfscanning.vue?vue&type=style&index=0&id=231b3c25&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231b3c25",
  null
  
)

export default component.exports